import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-extended-mat-table-multi-valor',
  styleUrls: ['./extended-mat-table.component.scss'],
  template: `
    <ng-container [ngSwitch]="separador">
      <ng-container *ngSwitchCase="'br'">
        <p matTooltip="{{ item.columnDef }} {{ this.parent.format(elemento[item.campo], item.format) }}" class="row-span"  *ngFor="let item of campos; index as i" [class]="item.cssClass">
          <span  >{{ item.columnDef }}</span> {{ this.parent.format(elemento[item.campo], item.format) }}<ng-container *ngIf="i < campos.length-1;"><br /></ng-container>
        </p>
      </ng-container>
      <ng-container *ngSwitchCase="'hifen'">
        <ng-container  *ngFor="let item of campos; index as i" [class]="item.cssClass">
          <span  matTooltip="{{ item.columnDef }} {{ this.parent.format(elemento[item.campo], item.format) }}" class="row-span">{{ item.columnDef }}</span> {{ this.parent.format(elemento[item.campo], item.format) }}<ng-container *ngIf="i < campos.length-1;"> - </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container  *ngFor="let item of campos; index as i" [class]="item.cssClass">
          <span  matTooltip="{{ item.columnDef }} {{ this.parent.format(elemento[item.campo], item.format) }}" class="row-span">{{ item.columnDef }}</span> {{ this.parent.format(elemento[item.campo], item.format) }}
        </ng-container>
      </ng-container>
    </ng-container>
  `
})
export class MultiValorColumnComponent implements OnInit {
  @Input() campos: any[] = []; // Recebe as colunas dinamicamente como input
  @Input() separador: string = ''; 
  @Input() elemento: any[] = []; 
  @Input() parent!: any; 

  ngOnInit() {
    
  }
}
